import React from "react";
import { useSelector } from "react-redux";
import IndividualUpgradeForm from "./IndividualUpgradeForm";
import CorporateUpgradeForm from "./CorporateUpgradeForm";

const MemberUpgradeForm = () => {
  const memberProfile = useSelector((state) => state.auth?.memberProfile);

  if (!memberProfile) return null;

  return memberProfile.userType === "Individual" ? (
    <IndividualUpgradeForm memberProfile={memberProfile} />
  ) : (
    <CorporateUpgradeForm memberProfile={memberProfile} />
  );
};

export default MemberUpgradeForm;
